import { createSelector } from '@ngrx/store';

import { EmailTemplate } from '@shared/models';

import { CollectionsState, getCollectionsState } from '../collections.reducer';

export const getEmailTemplatesState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.emilaTemplates,
);

export const getRejectCandidateEmailTemplatesState = createSelector(
  getEmailTemplatesState,
  (state) => state.rejectCandiate,
);

export const getRejectCandidateEmailTemplates = createSelector(
  getRejectCandidateEmailTemplatesState,
  (state) => [noneTemplae, ...state.templates]
);

const noneTemplae: EmailTemplate = {
  id: null,
  title: `None (don't send email)`
} as EmailTemplate;
